import { useState } from 'react';
import AppCard from '../components/AppCard';

export default function AllApps({ apps, appStats, loading, totals }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('commission');
  const [statusFilter, setStatusFilter] = useState('all');

  const { totalApps, activeApps } = totals;

  // Filter and sort apps
  const filteredApps = apps
    .filter(app => {
      if (statusFilter === 'all') return true;
      const isActive = (appStats[app.app_id]?.thisMonth || 0) > 0;
      return statusFilter === 'active' ? isActive : !isActive;
    })
    .filter(app => {
      if (!searchTerm) return true;
      const search = searchTerm.toLowerCase();
      return (
        app.app_id.toString().includes(search) ||
        (app.homepage && app.homepage.toLowerCase().includes(search)) ||
        (app.redirect_uri && app.redirect_uri.toLowerCase().includes(search)) ||
        (app.name && app.name.toLowerCase().includes(search))
      );
    })
    .sort((a, b) => {
      const statsA = appStats[a.app_id] || { today: 0, thisMonth: 0, lastMonth: 0 };
      const statsB = appStats[b.app_id] || { today: 0, thisMonth: 0, lastMonth: 0 };
      
      if (sortBy === 'commission') {
        return statsB.thisMonth - statsA.thisMonth;
      } else if (sortBy === 'today') {
        return statsB.today - statsA.today;
      } else if (sortBy === 'lastMonth') {
        return statsB.lastMonth - statsA.lastMonth;
      } else if (sortBy === 'clients') {
        return (statsB.clients || 0) - (statsA.clients || 0);
      } else {
        return b.app_id - a.app_id;
      }
    });

  if (loading) {
    return (
      <div className="all-apps-page all-apps-loading" aria-busy="true">
        <div className="controls-bar loading-controls" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <div className="all-apps-grid loading-app-grid" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    );
  }

  return (
    <div className="all-apps-page">
      {/* Search and Sort */}
      <div className="controls-bar">
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Search by App ID, domain, or URL..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="all">All statuses</option>
          <option value="active">Active only</option>
          <option value="inactive">Inactive only</option>
        </select>

        <select
          className="sort-select"
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
        >
          <option value="commission">Sort by This Month</option>
          <option value="today">Sort by Today</option>
          <option value="lastMonth">Sort by Last Month</option>
          <option value="clients">Sort by Clients</option>
          <option value="id">Sort by ID</option>
        </select>
      </div>

      {/* App Count */}
      <p className="app-count">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>Showing <strong>{filteredApps.length}</strong> of <strong>{totalApps}</strong> apps</span>
        <span className="app-count-active">{activeApps} active</span>
      </p>

      {/* App Cards Grid */}
      <div className="all-apps-grid">
        {filteredApps.map(app => (
          <AppCard
            key={app.app_id}
            app={app}
            stats={appStats[app.app_id] || { today: 0, thisMonth: 0, lastMonth: 0, transactions: 0, volume: 0, payout: 0, clients: 0, sharePercent: 0 }}
          />
        ))}
      </div>

      {filteredApps.length === 0 && (
        <div className="no-results">
          <p>No apps found matching your search.</p>
        </div>
      )}
    </div>
  );
}
